import { cva, type VariantProps } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import * as React from 'react';

import { cn } from '../../lib/cn';

const spinnerVariants = cva('animate-spin', {
	variants: {
		size: {
			sm: 'h-3 w-3',
			md: 'h-4 w-4',
			lg: 'h-6 w-6',
			xl: 'h-8 w-8',
		},
		tone: {
			accent: 'text-accent',
			muted: 'text-text-muted',
			inherit: 'text-inherit',
		},
	},
	defaultVariants: {
		size: 'md',
		tone: 'accent',
	},
});

export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
	/** Dimensione dell'icona di caricamento. Default: `md`. */
	size?: VariantProps<typeof spinnerVariants>['size'];
	/** Colore dell'icona. Default: `accent`. */
	tone?: VariantProps<typeof spinnerVariants>['tone'];
}

/** Icona rotante per indicare uno stato di caricamento in linea (dentro bottoni, card, sezioni). */
const Spinner = ({ className, size, tone, ...props }: SpinnerProps) => (
	<Loader2
		aria-label="Caricamento"
		className={cn(spinnerVariants({ size, tone, className }))}
		{...props}
	/>
);
Spinner.displayName = 'Spinner';

/** Spinner centrato a tutta pagina, per il caricamento di un'intera rotta/schermata. */
const FullScreenLoader = () => (
	<div className="flex h-screen w-full items-center justify-center bg-background">
		<Spinner size="xl" />
	</div>
);
FullScreenLoader.displayName = 'FullScreenLoader';

export { FullScreenLoader, Spinner, spinnerVariants };
